import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.fiveSection;

export default [
  {
    ...textInfo[0]
  },
  {
    ...textInfo[1]
  },
  {
    ...textInfo[2]
  },
  {
    ...textInfo[3]
  },
  {
    ...textInfo[4]
  },
  {
    ...textInfo[5]
  },
  {
    ...textInfo[6]
  }
];
